import { cn } from '@cobliteam/colib-ui/cn';
import { activeBarColor, trackGlobalSearchEvents } from '../helpers';
import { useSearch } from '../hooks/useSearch';
import { type DeviceWithCategory, EnumCategory, type GeofenceWithCategory, type PageWithCategory, type VehicleWithCategory } from '../types';
import { CommandItem } from './Command';
import DeviceItem from './Details/Device/DeviceItem';
import GeofenceItem from './Details/Geofence/GeofenceItem';
import { PageItem } from './Details/Page/PageItem';
import VehicleItem from './Details/Vehicle/VehicleItem';
import { ItemContent } from './ItemContent';

interface VirtualizedItemProps {
  virtualRow: { index: number; start: number };
}

export const VirtualizedItem = ({ virtualRow }: VirtualizedItemProps) => {
  const { setSelectedItem, resultsByCategory, category, selectedItem } = useSearch();

  const item = resultsByCategory[virtualRow.index];
  const isActive = selectedItem?.id === item.id;

  const handleItemSelect = () => {
    trackGlobalSearchEvents.itemClick(item?.id || '', item.category.id as EnumCategory, item[category.labelKey as keyof typeof item] as string);
    setSelectedItem(item);
  };

  return (
    <CommandItem
      key={virtualRow.index}
      onSelect={handleItemSelect}
      className={cn(
        // Keeps the look of the @cobliteam/ui CommandItem this list used before.
        'cursor-pointer gap-2 font-normal text-muted-foreground hover:bg-muted data-[selected=true]:font-normal data-[selected=true]:text-accent-foreground',
        "data-[selected='true']:bg-accent [&_svg]:pointer-events-none [&_svg]:mr-0 [&_svg]:size-4 [&_svg]:shrink-0",
        isActive && 'bg-background text-foreground shadow-none after:bg-primary',
        isActive && activeBarColor(item.category.color),
        '!top-0 !left-0 !w-full !h-[46px] absolute rounded-none border-border border-b',
        'after:absolute after:inset-y-0 after:start-0 after:w-[2px]'
      )}
      style={{ transform: `translateY(${virtualRow.start}px)` }}
    >
      {item.category.id === EnumCategory.VEHICLES && <VehicleItem item={item as VehicleWithCategory} />}
      {item.category.id === EnumCategory.DRIVERS && <ItemContent item={item} />}
      {item.category.id === EnumCategory.VEHICLE_GROUPS && <ItemContent item={item} />}
      {item.category.id === EnumCategory.DEVICES && <DeviceItem item={item as DeviceWithCategory} />}
      {item.category.id === EnumCategory.GEOFENCES && <GeofenceItem item={item as GeofenceWithCategory} />}
      {item.category.id === EnumCategory.PAGES && <PageItem item={item as PageWithCategory} />}
    </CommandItem>
  );
};
